import React from 'react';
import { CSpinner } from '@coreui/react-pro'
const Loading = ({children}) => {
  return (
    <div style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",minHeight:"100vh"}}><CSpinner color="primary" /></div>
  )
}
export default Loading;
